import './App.css';
import { BrowserRouter } from "react-router-dom";
import Routing from "./Routes/router";
import Store from './redux/store';
import { Provider } from 'react-redux';
// import CircularProgress from '@mui/material/CircularProgress';
// import Backdrop from '@mui/material/Backdrop';
import AuthFunctions from './components/helpers/authservice';
import { ToastContainer } from 'react-bootstrap';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SessionExpiredModal from './components/helpers/sessionexpiredModal';

// import { useSelector } from 'react-redux';

function App() {
  // const isLoading = useSelector((state) => state.loginReducer.isLoading);

  return (
    <Provider store={Store}>
      <BrowserRouter basename='/admin'>
        <AuthFunctions>
          {({ handleLogout }) => (
            <>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Routing
                  handleLogout={handleLogout}
                />
              </LocalizationProvider>
              <SessionExpiredModal handleLogout={handleLogout} />

              {/* <Backdrop className="spinner-backdrop" open={isLoading}>
                <CircularProgress color="primary" />
              </Backdrop> */}
            </>
          )}
        </AuthFunctions>
      </BrowserRouter>
    </Provider>

  );
}

export default App;
